<div class="ibm--footer-space"></div>
<footer class="small--xs muted py-5 text-center">
  Ⓒ IBM
  <strong>RXN</strong>
</footer>